"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _MoreVert = _interopRequireDefault(require("@mui/icons-material/MoreVert"));
var _reactAvatar = _interopRequireDefault(require("react-avatar"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid/Grid"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu/Menu"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem"));
var _theme = require("../../theme");
var _Text = _interopRequireDefault(require("../Text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SingleLineDisplayCard = /*#__PURE__*/function (_Component) {
  function SingleLineDisplayCard() {
    var _this;
    (0, _classCallCheck2["default"])(this, SingleLineDisplayCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, SingleLineDisplayCard, [].concat(args)), _this.state = {
      anchorEl: null
    }, _this._handleMenuClick = function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    }, _this._handleCloseMenu = function () {
      _this.setState({
        anchorEl: null
      });
    }, _this._editSegment = function () {
      _this._handleCloseMenu();
      _this.props.onSelect();
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(SingleLineDisplayCard, _Component);
  return (0, _createClass2["default"])(SingleLineDisplayCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        popUpText = _this$props.popUpText,
        id = _this$props.id,
        testid = _this$props.testid;
      var styles = {
        cardBlock: _theme.globalStyles.cardBlock,
        sansShadow: {
          boxShadow: 'none'
        },
        itemBorder: {
          borderBottom: "1px solid ".concat(_theme.colors.borderGrey)
        },
        cardTitle: _theme.globalStyles.cardTitle,
        singleLineCard: _theme.globalStyles.singleLineCard
      };
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        alignItems: "center",
        style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styles.cardBlock), styles.singleLineCard), styles.sansShadow), styles.itemBorder)
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 2,
        sm: 2,
        md: 1
      }, /*#__PURE__*/_react["default"].createElement(_reactAvatar["default"], {
        name: this.props.segment.title,
        size: "40",
        textSizeRatio: 2.2,
        round: false
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 8,
        sm: 9,
        md: 10
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "column",
        alignItems: "flex-start"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        id: id || testid,
        style: styles.cardTitle
      }, this.props.segment.title))), this.props.onSelect && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 2,
        sm: 1,
        md: 1,
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        "aria-label": "Edit",
        onClick: this._handleMenuClick
      }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null)), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        anchorEl: this.state.anchorEl,
        open: Boolean(this.state.anchorEl),
        onClose: this._handleCloseMenu,
        disableAutoFocusItem: true
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: this._editSegment
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        align: "center",
        color: "inherit",
        medium: true,
        display: "inline"
      }, popUpText)))));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = SingleLineDisplayCard;